module.exports = __webpack_public_path__ + "img/icon_Hybridenergy.b714f282.png";